<div class="flex justify-between items-center mb-6">
  <h1 mat-dialog-title class="text-xl font-bold m-0 p-0 text-start">
    {{ data ? "Edit" : "Create" }} Role
  </h1>
  <button mat-icon-button (click)="closeDialog()" type="button">
    <mat-icon
      class="text-gray-500"
      [svgIcon]="'heroicons_outline:x-mark'"
    ></mat-icon>
  </button>
</div>

<form [formGroup]="roleForm" (ngSubmit)="onSubmit()" class="space-y-6">
  <div mat-dialog-content class="m-0 p-0 overflow-x-hidden">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 mb-8">
      <div>
        <label class="block text-[15px] font-semibold text-gray-700 mb-1"
          >Role Name<span class="text-red-500">*</span></label
        >
        <input
          formControlName="name"
          placeholder="Enter role name"
          maxlength="100"
          [readonly]="data?.name === 'Vendor Default'"
          [class.text-gray-400]="data?.name === 'Vendor Default'"
          [class.cursor-not-allowed]="data?.name === 'Vendor Default'"
          [class.pointer-events-none]="data?.name === 'Vendor Default'"
          [class.border-red-500]="roleForm.get('name')?.touched && roleForm.get('name')?.invalid"
          class="w-full border border-gray-300 rounded-md px-3 py-2 text-[13px] text-black focus:outline-none focus:border-red-800"
        />
        <div *ngIf="roleForm.get('name')?.touched && roleForm.get('name')?.hasError('required')" class="text-red-500 text-xs mt-1">Role Name is required.</div>
        <div *ngIf="roleForm.get('name')?.touched && roleForm.get('name')?.hasError('pattern')" class="text-red-500 text-xs mt-1">Role Name cannot contain only spaces.</div>
        <div *ngIf="roleForm.get('name')?.touched && roleForm.get('name')?.hasError('maxlength')" class="text-red-500 text-xs mt-1">Role Name cannot exceed 100 characters.</div>
      </div>

      <div>
        <label class="block text-[15px] font-semibold text-gray-700 mb-1"
          >Role Description<span class="text-red-500">*</span></label
        >
        <input
          formControlName="desc"
          placeholder="Enter description"
          [class.border-red-500]="roleForm.get('desc')?.touched && roleForm.get('desc')?.invalid"
          class="w-full border border-gray-300 rounded-md px-3 py-2 text-[13px] text-black focus:outline-none focus:border-red-800"
        />
        <div *ngIf="roleForm.get('desc')?.touched && roleForm.get('desc')?.hasError('required')" class="text-red-500 text-xs mt-1">Role Description is required.</div>
      </div>

      <div>
        <label class="block text-[15px] font-semibold text-gray-700 mb-1"
          >Department Name<span class="text-red-500">*</span></label
        >
        <input
          formControlName="department"
          placeholder="Enter department name"
          [class.border-red-500]="roleForm.get('department')?.touched && roleForm.get('department')?.invalid"
          class="w-full border border-gray-300 rounded-md px-3 py-2 text-[13px] text-black focus:outline-none focus:border-red-800"
        />
        <div *ngIf="roleForm.get('department')?.touched && roleForm.get('department')?.hasError('required')" class="text-red-500 text-xs mt-1">Department Name is required.</div>
      </div>

      <div>
        <label class="block text-[15px] font-semibold text-gray-700 mb-1"
          >User Type<span class="text-red-500">*</span></label
        >
        <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
          <mat-select formControlName="userRoleType" placeholder="Select user type">
            <mat-option value="user">User</mat-option>
            <mat-option value="vendor">Vendor</mat-option>
            <mat-option value="reviewer">Reviewer</mat-option>
            <mat-option value="evaluator">Evaluator</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="roleForm.get('userRoleType')?.touched && roleForm.get('userRoleType')?.hasError('required')" class="text-red-500 text-xs mt-1">Please select a User Type.</div>
      </div>
    </div>

    <div class="border border-gray-200 rounded-lg shadow-sm bg-white mb-2">
      <div
        class="flex justify-between items-center p-4 border-b border-gray-100 cursor-pointer"
        (click)="isModularPermissionsExpanded = !isModularPermissionsExpanded"
      >
        <span class="text-[15px] font-semibold text-gray-800"
          >Modular Permissions</span
        >
        <mat-icon class="text-gray-400 transition-transform" [class.rotate-180]="!isModularPermissionsExpanded">expand_more</mat-icon>
      </div>

      <div class="p-5 grid grid-cols-1 md:grid-cols-2 gap-5" *ngIf="isModularPermissionsExpanded">
        <div
          *ngFor="let module of roleData"
          class="border border-gray-200 rounded-md bg-white shadow-sm flex flex-col transition-all"
        >
          <div class="flex justify-between items-center p-3">
            <mat-checkbox
              [checked]="isAtLeastOnePermissionEnabled(module)"
              (change)="onModuleCheck(module)"
              class="text-[13px] font-semibold text-gray-800"
            >
              {{ module.label || module.moduleName || module.key }}
            </mat-checkbox>
            <mat-icon
              class="text-gray-400 cursor-pointer transition-transform"
              [class.rotate-180]="module.isExpanded"
              (click)="module.isExpanded = !module.isExpanded"
            >
              expand_more
            </mat-icon>
          </div>

          <div
            class="p-4 pt-0 bg-white"
            *ngIf="module.isExpanded && module.subModules?.length > 0"
          >
            <div class="text-[12px] text-gray-400 mb-3 tracking-wide">
              Functional Permissions
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-2">
              <div *ngFor="let sub of module.subModules">
                <mat-checkbox
                  [checked]="sub.permissions?.[getEnabledAction(sub)]"
                  (change)="togglePermission(sub, getEnabledAction(sub), module)"
                  [disabled]="sub.disabledPermissions?.includes(getEnabledAction(sub))"
                  class="text-[12px] text-gray-600 font-normal"
                >
                  {{ getDisplayPermissionName(sub.name) }}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <fuse-alert
      *ngIf="showAlert"
      class="mt-6"
      [appearance]="'outline'"
      [showIcon]="false"
      [type]="alert.type"
    >
      {{ alert.message }}
    </fuse-alert>
  </div>

  <div
    mat-dialog-actions
    class="flex justify-center items-center gap-4 pt-4 pb-2 m-0 border-none"
  >
    <button
      type="button"
      (click)="closeDialog()"
      class="px-8 py-2 rounded-full border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 transition-colors font-medium"
    >
      Go back
    </button>
    <button
      type="submit"
      class="px-10 py-2 rounded-full text-white transition-colors font-medium shadow-sm"
      style="background-color: #8b0000"
    >
      {{ data ? "Update" : "Create" }}
    </button>
  </div>
</form>
